import React from 'react';
import * as ToastPrimitive from '@radix-ui/react-toast';
import './style.css';

interface ToastProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description?: string;
  type?: 'success' | 'error' | 'info';
}

export const Toast: React.FC<ToastProps> = ({
  open,
  onOpenChange,
  title,
  description,
  type = 'info'
}) => {
  return (
    <ToastPrimitive.Provider>
      <ToastPrimitive.Root
        className={`toast-root ${type}`}
        open={open}
        onOpenChange={onOpenChange}
      >
        <ToastPrimitive.Title className="toast-title">
          {title}
        </ToastPrimitive.Title>
        {description && (
          <ToastPrimitive.Description className="toast-description">
            {description}
          </ToastPrimitive.Description>
        )}
      </ToastPrimitive.Root>
      <ToastPrimitive.Viewport className="toast-viewport" />
    </ToastPrimitive.Provider>
  );
};